import React, { useState, useEffect } from "react";
import { WebAPIClient } from "@skygear/web";
import { ServiceContextProvider } from "./contexts/ServiceContext";
import { GlobalDragAndDropProvider } from "./contexts/GlobalDragAndDropContext";
import { APIClient } from "./api/APIClient";
import { I18nProvider } from "./i18n";
import config from "./config";
import "./App.scss";
import Navigator from "./screens/Navigator";
import { useOrderQueryToken } from "./useCases/token";
import LoadingScreen from "./screens/LoadingScreen";
import { ToastProvider } from "./contexts/ToastContext";

const App: React.FC = () => {
  const token = useOrderQueryToken();
  const [container, setContainer] = useState<APIClient<WebAPIClient> | null>(
    null
  );

  useEffect(() => {
    if (token != null) {
      new APIClient(token)
        .configure({
          apiKey: config.skygear.apiKey,
          endpoint: config.skygear.endpoint,
        })
        .then(apiClient => {
          setContainer(apiClient);
        })
        .catch(error => console.error(error));
    }
  }, [token]);

  if (container === null) {
    return <LoadingScreen />;
  }

  return (
    <I18nProvider>
      <ServiceContextProvider value={container}>
        <GlobalDragAndDropProvider>
          <ToastProvider>
            <Navigator />
          </ToastProvider>
        </GlobalDragAndDropProvider>
      </ServiceContextProvider>
    </I18nProvider>
  );
};

export default App;
